import { gql } from "@apollo/client";
import { AccountFragment } from "fragments/account";

export const PointFragment = gql`
  fragment PointFragment on Point {
    id
    pointId
    description
    
    dimensions
    measures

    status

    createdAt
    updatedAt
  }
`;

export const get = gql`
  query PointGet($pointId: String!) {
    viewer {
      id
      account {
        ...AccountFragment
        points {
          id
          get(pointId: $pointId) {
            ...PointFragment
          }
        }
      }
    }
  }
  ${AccountFragment}
  ${PointFragment}
`;

export const list = gql`
  query PointList($input: ListInput) {
    viewer {
      id
      account {
        id
        points {
          id
          list(input: $input) {
            id
            last
            items {
              ...PointFragment
            }
          }
        }
      }
    }
  }
  ${PointFragment}
`;




export const create = gql`
  mutation PointNew($input: PointInputCreate!) {
    viewer {
      account {
        points {
          create(input: $input) {
            ...PointFragment
          }
        }
      }
    }
  }
  ${PointFragment}
`;



export const edit = gql`
  mutation PointEdit(
    $pointId: String!
    $input: PointInputUpdate!
  ) {
    viewer {
      account {
        points {
          get(pointId: $pointId) {
            update(input: $input) {
              ...PointFragment
            }
          }
        }
      }
    }
  }
  ${PointFragment}
`;


export const remove = gql`
  mutation PointRemove($pointId: String!) {
    viewer {
      account {
        points {
          get(pointId: $pointId) {
            remove 
          }
        }
      }
    }
  }

`;




export const update = ({ pointId }) => (cache) => {

  Object.keys(cache.data.data).forEach((key) => {
    if (key.includes(`points/queries`)) {
      cache.data.delete(key);
    }
  });
};
